module.exports = __webpack_public_path__ + "img/partners_aoweiya.96f0938a.png";